// extracted by mini-css-extract-plugin
export default {"font-renta":"InlineTooltip_font-renta__H3UOr","tooltip":"InlineTooltip_tooltip__Tgv5Q"};